import {
    Button,
    Flex,
    Heading,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useColorModeValue
} from '@chakra-ui/react'
import { Icon, Logo } from 'components/atoms'
import { IconClose } from 'components/molecules/ModalBuild/styles'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export type TypeModalNotification = {
    guid: string
    titulo: string
    descricao: string
}
const ModalNotification: React.FC = () => {
    const navigate = useNavigate()
    const [visible, setVisible] = useState(true)
    const closeModal = () => {
        setVisible(false)
    }

    const goToNotificationsList = () => {
        navigate('/comunicacao')
        closeModal()
    }

    const bgColor = useColorModeValue('white', 'gray.800')
    const borderColor = useColorModeValue('primary.200', 'primary.400')
    const headingColor = useColorModeValue('primary.700', 'primary.300')

    return (
        <Modal
            closeOnEsc={false}
            closeOnOverlayClick={false}
            onClose={closeModal}
            isOpen={visible}
            isCentered
            size="lg"
            motionPreset="slideInBottom"
        >
            <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(5px)" />
            <ModalContent
                mx={6}
                borderRadius="xl"
                overflow="hidden"
                boxShadow="xl"
                bg={bgColor}
            >
                <ModalHeader
                    py={5}
                    px={6}
                    borderBottomWidth="2px"
                    borderColor={borderColor}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Logo type="default" maxW="130px" />
                    <IconClose name="close" onClick={closeModal} />
                </ModalHeader>

                <ModalBody py={8} px={6}>
                    <Flex
                        direction="column"
                        align="center"
                        justify="center"
                        textAlign="center"
                    >
                        <Flex
                            align="center"
                            mb={4}
                            bg="primary.50"
                            p={3}
                            borderRadius="full"
                        >
                            <Icon name="bell" size={40} />
                        </Flex>

                        <Heading
                            fontSize="2xl"
                            mb={4}
                            color={headingColor}
                            fontWeight="700"
                        >
                            Você tem notificações não lidas!
                        </Heading>

                        <Text
                            fontSize="md"
                            color="gray.600"
                            maxW="md"
                            lineHeight="tall"
                        >
                            Fique por dentro das últimas atualizações! Vá até a
                            tela de notificações para conferir o que há de novo
                            e não perder nenhuma informação importante.
                        </Text>
                    </Flex>
                </ModalBody>

                <ModalFooter
                    py={5}
                    px={6}
                    borderTopWidth="1px"
                    borderColor="gray.200"
                    display="flex"
                    justifyContent="space-between"
                    bg="gray.50"
                >
                    <Button
                        variant="outline"
                        colorScheme="gray"
                        onClick={closeModal}
                        size="md"
                        fontWeight="medium"
                    >
                        Fechar
                    </Button>

                    <Button
                        colorScheme="primary"
                        onClick={goToNotificationsList}
                        size="md"
                        fontWeight="medium"
                    >
                        Ver notificações
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalNotification
